<template>
  <div class="category-select">
    <el-select 
      v-if="!hasSubCategories" 
      v-model="selectedCategory" 
      :placeholder="placeholder" 
      :size="size" 
      :style="customStyle"
      :clearable="clearable"
      @change="handleChange"
    >
      <el-option
        v-for="cat in categoryList"
        :key="cat.id"
        :label="cat.categoryName"
        :value="cat.id"
      >
        <i v-if="showIcon" :class="cat.icon || 'el-icon-folder'" style="margin-right: 5px;"></i>
        <span>{{ cat.categoryName }}</span>
      </el-option>
    </el-select>
    <el-cascader
      v-else
      v-model="selectedCategory"
      :options="categoryOptions"
      :props="{ value: 'id', label: 'categoryName', children: 'children', checkStrictly: true, emitPath: false }"
      :placeholder="placeholder"
      :size="size"
      :style="customStyle"
      :clearable="clearable"
      :show-all-levels="false"
      @change="handleChange"
    ></el-cascader>
  </div>
</template>

<script>
export default {
  name: 'CategorySelect',
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    placeholder: {
      type: String,
      default: '全部分类'
    },
    size: {
      type: String,
      default: 'small'
    },
    customStyle: {
      type: String,
      default: 'width: 150px;'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    includeAllOption: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedCategory: this.value,
      categoryList: [],
      categoryTree: [],
      categoryOptions: [],
      hasSubCategories: false,
      loading: false
    };
  },
  watch: {
    value(val) {
      this.selectedCategory = val;
    }
  },
  created() {
    this.getCategoryTree();
  },
  methods: {
    async getCategoryTree() {
      try {
        const response = await this.$axios({
          method: 'post',
          url: '/category/categoryTree',
          data: {}
        });
        if (response.code === '200' && response.data) {
          this.categoryTree = response.data.children || [];
          this.categoryList = this.flattenCategoryTree(this.categoryTree);
          
          if (this.includeAllOption) {
            this.categoryOptions = [{ 
              id: 0, 
              categoryName: '全部分类', 
              children: this.categoryTree 
            }];
          } else {
            this.categoryOptions = this.categoryTree;
          }
          
          this.hasSubCategories = this.categoryTree.some(cat => cat.children && cat.children.length > 0);
        }
      } catch (error) {
        console.error('获取分类树失败:', error);
      }
    },
    flattenCategoryTree(tree) {
      let result = [];
      tree.forEach(node => {
        const nodeWithoutChildren = { ...node };
        delete nodeWithoutChildren.children;
        result.push(nodeWithoutChildren);
        if (node.children && node.children.length > 0) {
          result = result.concat(this.flattenCategoryTree(node.children));
        }
      });
      return result;
    },
    handleChange(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    }
  }
};
</script>

<style scoped lang="less">
.category-select {
  ::v-deep .el-select {
    width: 100%;
  }
  
  ::v-deep .el-cascader {
    width: 100%;
  }
}
</style>
